export default "__VITE_ASSET__BnHuqg9A__"